import hasLocaleInPath from './hasLocaleInPath';
import getPathPieces from './getPathPieces';

export default function getLocaleFromPath(path: string) {
  if (hasLocaleInPath(path)) {
    return getPathPieces(path)[0];
  }
}
